import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { FilteringRuleSliceDTO, fromDTO, GET_FILTERING_RULES } from './api'
import { Data, Variables } from './api/types'
import { FilteringRuleForTable, UseGetFilteringRules, UseGetFilteringRulesProps } from './types'

export const useGetFilteringRules = ({
  filters,
  first,
  last,
  sort,
}: UseGetFilteringRulesProps): UseGetFilteringRules => {
  const { workspaceId } = useWorkspaceParam()
  const [filteringRules, setFilteringRules] = useState<FilteringRuleForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading } = useQuery<Variables, Data>({
    onCompleted: async ({ filteringRules: { nodes: rules, totalCount: count } }: Data) => {
      if (rules) {
        setFilteringRules(
          rules.map((rule: FilteringRuleSliceDTO): FilteringRuleForTable => fromDTO(rule)),
        )
      }
      setCount(count)
    },
    query: GET_FILTERING_RULES,
    variables: {
      first,
      last,
      sort,
      terms: filters,
      workspaceId,
    },
  })

  return {
    count,
    filteringRules,
    loading: isLoading,
  }
}
